@if (entry.question) {
  <div class="question">{{ entry.question }}</div>
}
@switch (entry.displayType) {
  @case ('dropdown') {
    <mat-form-field>
      <mat-label>{{ entry.label }}</mat-label>
      <mat-select [formControlName]="formIndex">
        @for (option of entry.options; track option; let optionIndex = $index) {
          <mat-option [value]="optionIndex">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @case ('radio') {
    <div class="boxes">
      <mat-radio-group [formControlName]="formIndex">
        @if (entry.label) {
          <div>{{ entry.label }}</div>
        }
        @for (option of entry.options; track option; let optionIndex = $index) {
          <mat-radio-button [value]="optionIndex">
            {{ option }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }
}
